document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('.loe-page-section .fade-up');
  if (!targets.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  targets.forEach((el, i) => {
    el.style.transitionDelay = (i * 0.08) + 's';
    io.observe(el);
  });
});